import React from 'react';

const ProcessingPopup = ({message}) => {
  return (
    <div className="popup">
    <div className="popup-content">
    <div  className="text-center pt-2" > 
    <img src="media/loader1.svg" className="w-10"  />
    </div>
      <div className="text-center mt-2 ev-fs-12 ev-bold-reg"><p>{message}</p></div>
    </div>
    </div>

  );
};

export default ProcessingPopup;